import React, { useState, useEffect, useMemo, useContext } from 'react';
import { message, Col, Row, Select, Carousel, Divider, Checkbox } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { AppContext } from '@utils/AppContext';
import styles from './index.module.scss'
import { GenerateContext } from '@utils/GenerateContext';
import { IMAGE_TYPE } from "@utils/CONST"
import API from '@api/api'

const ModelFilterSelect = (props) => {
    const { globalUser } = useContext(AppContext);
    const [skin, setSkin] = useState([]);
    const [sex, setSex] = useState([]);
    const [age, setAge] = useState([]);
    const [toneTags, setToneTags] = useState([]);
    const [clothesCate, setClothesCate] = useState([]);
    const [algoModelType, setAlgoModelType] = useState([]);
    const [posture, setPosture] = useState([])
    const [clothesCateOpts, setClothesCateOpts] = useState([])

    useEffect(() => {
        setSkin([...props.filterValue?.skin || []])
        setSex([...props.filterValue?.sex || []])
        setAge([...props.filterValue?.age || []])
        setToneTags([...props.filterValue?.toneTags || []])
        setClothesCate([...props.filterValue?.clothesCate || []])
        setAlgoModelType([...props.filterValue?.algoModelType || []])
        setPosture([...props.filterValue?.posture || []])
    }, [props.filterValue])

    const optFactory = (opt, placeholder) => {
        return {
            mode: "multiple",
            allowClear: true,
            showSearch: false,
            style: { width: props.width || props.showLabel ? 'calc(100% - 60px)' : '100%' },
            size: 'small',
            maxTagCount: 'responsive',
            placeholder: placeholder,
            options: opt
        }
    }

    const [sexTagOpts, setSexTagOpts] = useState([])
    const [ageTagsOpts, setAgeTagsOpts] = useState([])
    const [skinTagsOpts, setSkinTagsOpts] = useState([])
    const [toneTagsOpts, setToneTagsOpts] = useState([])
    useEffect(() => {
        Promise.all([
            API.categoryList({
                func: 'person',
                category: 'sexTag',
                resourceType: 'model',
            }),
            API.categoryList({
                func: 'person',
                category: 'ageTags',
                resourceType: 'model',
            }),
            API.categoryList({
                func: 'person',
                category: 'skinTags',
                resourceType: 'model',
            }),
            API.categoryList({
                func: 'person',
                category: 'toneTags',
                resourceType: 'model',
            })
        ]).then(([res1, res2, res3, res4]) => {
            setSexTagOpts(res1.data || [])
            setAgeTagsOpts(res2.data || [])
            setSkinTagsOpts(res3.data || [])
            setToneTagsOpts(res4.data || [])
        }).catch(err => {
            message.error(err.message)
        })
    }, [])

    const sexOpts = [{
        value: 'female',
        label: '女',
    }, {
        value: 'male',
        label: '男',
    }]

    const ageOpts = [{
        value: 'adult',
        label: '成年',
    }, {
        value: 'children',
        label: '儿童',
    }]

    const skinOpts = [{
        label: '黄',
        value: 'yellow',
    }, {
        label: '白',
        value: 'white',
    }, {
        label: '黑',
        value: 'black',
    }]


    const shoesCategoryList = () => {
        API.shoesCategoryList({
            category: 'clothesCate',
            resourceType: 'tryon',
        }).then(res => {
            if (res.code != 0) throw new Error(res.message)
            const list = res.data.map(item => ({ label: item.display, value: item.value }))
            setClothesCateOpts(list || [])
        }).catch(err => {
            message.error(err.message)
        }).finally(() => {
            console.log('finally')
        })
    }

    const handleChange2 = (value, key) => {
        switch (key) {
            case 1:
                props.onChange({ sex: [...value] })
                break;
            case 2:
                props.onChange({ age: [...value] })
                break;
            case 3:
                props.onChange({ skin: [...value] })
                break;
            case 4:
                props.onChange({ posture: [...value] })
                break;
            case 5:
                props.onChange({ algoModelType: [...value] })
                break;
            case 6:
                props.onChange({ clothesCate: [...value] })
                break;
            case 7:
                props.onChange({ toneTags: [...value] })
                break;
        }
    }

    const tagRender = (props) => {
        const { label } = props;
        return <span className={styles.ModelFilterSelect_tag}>{label}</span>
    }

    const showClothesCate = useMemo(() => {
        return props.imageType == IMAGE_TYPE.CLOTHES && props.isPose
    }, [props.imageType, props.isPose])

    const colSpan = useMemo(() => {
        return (props.imageType == IMAGE_TYPE.CLOTHES && props.isPose) ? 6 : 6
    }, [props.imageType, props.isPose])

    useEffect(() => {
        if (showClothesCate) shoesCategoryList()
    }, [showClothesCate])

    return (
        <Row className={styles.ModelFilterSelect} style={{ maxWidth: '800px' }} gutter={10}>
            {
                !props.showLabel &&
                <>
                    <Col span={colSpan}>
                        {props.showLabel && <label htmlFor="modal-sex">性别</label>}
                        <Select id='modal-sex' {...optFactory(sexTagOpts, '性别')} value={sex} onChange={v => handleChange2(v, 1)} tagRender={tagRender} />
                    </Col>
                    <Col span={colSpan}>
                        {props.showLabel && <label htmlFor="modal-skin">肤色</label>}
                        <Select id='modal-skin' {...optFactory(skinTagsOpts, '肤色')} value={skin} onChange={v => handleChange2(v, 3)} tagRender={tagRender} />
                    </Col>
                    <Col span={colSpan}>
                        {props.showLabel && <label htmlFor="modal-age">年龄</label>}
                        <Select id='modal-age' {...optFactory(ageTagsOpts, '年龄')} value={age} onChange={v => handleChange2(v, 2)} tagRender={tagRender} />
                    </Col>
                    {
                        !showClothesCate && <Col span={colSpan}>
                            {props.showLabel && <label htmlFor="modal-age">气质类型</label>}
                            <Select id='modal-toneTags' {...optFactory(toneTagsOpts, '气质类型')} value={toneTags} onChange={v => handleChange2(v, 7)} tagRender={tagRender} />
                        </Col>
                    }
                    {
                        showClothesCate && <Col span={colSpan}>
                            {props.showLabel && <label htmlFor="modal-age">服饰品类</label>}
                            <Select id='modal-clothesCate' {...optFactory(clothesCateOpts, '服饰品类')} value={clothesCate} onChange={v => handleChange2(v, 6)} tagRender={tagRender} />
                        </Col>
                    }
                </>
            }
        </Row>
    )
}

export default ModelFilterSelect